import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    order: null,
    orderState: 'NONE',
    lastUsedPaymentMethodId: null,
    subscriptionState: 'NONE', // NONE: Default, COMPLETED: Successfully created, PRE-SELECTED: pre selected before payment, FAILED: Failed on creation or confirming step
    orderErrorMessage: null,
    orderErrorType: null,
    orderStateChecks: 0,
    loadingOrderAndPayment: false,
    orderType: null,
    autoPurchase: null,
    paymentDataLoaded: false,
    order3DSChallange: null,
    savedPaymentMethods: null,
    savedPaymentMethodsLegacy: null,
    paymentMethodsLegacy: null,
    savedPaymentMethodsLoading: false,
    selectedPaymentMethod: false,
    addNewPaymentMethod: false,
    ordersInProgress: null,
    paymentMethodsFilter: false,
    prebookingInfo: null,
    prebookingPaymentInfo: null, // only use for 3DS redirection
    topupSubscriptionDataLoaded: false,
    preSelectedTopupSubscriptionFrequency: null
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout-v2/index.js